app.controller("LecturersIndexController", ["$scope", "StaticData", "Lecturer", "Users", "$uibModal", "ConfirmModal", "$stateParams", "$state", "toastr", "usSpinnerService", "$window",
    function ($scope, StaticData, Lecturer, Users, $uibModal, ConfirmModal, $stateParams, $state, toastr, usSpinnerService, $window) {
        $scope.query = $stateParams.query;
        $scope.lecturers = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.faculty = $stateParams.faculty;
        $scope.activeState = $stateParams.activeState;

        loadPage($stateParams.page,  $scope.query, function () {
            $scope.currentPage = $stateParams.page;
        });

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');
        });

        StaticData.getItemsByKey("lecturer_states").then(function (activeStates) {
            $scope.activeStates = [{name: "მდგომარეობა"}].concat(activeStates);
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, query, cb) {
            cb = cb || function () {
                };
            usSpinnerService.spin("root");

            Lecturer.list({
                page: page,
                query: query,
                limit: $scope.itemsPerPage,
                faculty: $scope.faculty,
                activeState: $scope.activeState
            }).then(function (data) {
                $scope.lecturers = data.docs;
                var lecturerList = data.docs;
                for (var i in lecturerList) {
                    if (!lecturerList[i].user.photo && lecturerList[i].user.gender == 'male') lecturerList[i].user.defaultPhoto = "img/male.jpg";
                    if (!lecturerList[i].user.photo && lecturerList[i].user.gender == 'female') lecturerList[i].user.defaultPhoto = "img/female.jpg";
                    else if (!lecturerList[i].user.photo && !lecturerList[i].user.gender) lecturerList[i].user.defaultPhoto = "img/no_image.jpg";
                }
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb()
            });
        }

        $scope.add = function () {
            $uibModal.open({
                controller: "AddLecturerController",
                templateUrl: _pb + 'admin/lecturers/add-lecturer.html',
                size: "md",
                backdrop: 'static',
            }).result
                .then(function (result) {
                    loadPage($stateParams.page);
                }, function () {
                });
        };

        $scope.editLecturer = function (lecturer, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "EditLecturerController",
                templateUrl: _pb + 'admin/lecturers/edit-lecturer.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    lecturer: function () {
                        return lecturer
                    }
                }
            }).result
                .then(function (result) {
                    loadPage($stateParams.page);
                }, function () {
                });
        };

        $scope.consultations = function (lecturer, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "AddMessageContainer",
                templateUrl: _pb + 'lecturer/add-message-container.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            subjectName: lecturer.user.firstName + ' ' + lecturer.user.lastName + ' - კონსულტაციების გრაფიკი',
                            lecturerId: lecturer._id
                        };
                    }
                }
            }).result
                .then(function () {
                    toastr.success('', 'კონსულტაციების გრაფიკი განახლებულია');
                    setTimeout(function () {
                        $window.location.reload();
                    }, 500);
                }, function () {
                });
        }

        $scope.showDetails = function (lecturer) {
            $state.go("admin.lecturerCard", {lecturerId: lecturer._id});
        };

        $scope.remove = function (lecture, $event) {
            var lectureId = lecture.user._id;

            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "ლექტორის წაშლა",
                message: "თქვენ შლით ლექტორს -  " + lecture.user.firstName + " " + lecture.user.lastName + ". გსურთ ლექტორის წაშლა ?"
            }).result.then(function () {
                Lecturer.remove(lectureId).then(function() {
                    toastr.success('ლექტორი წაშლილია');
                    return loadPage($scope.currentPage)
                })
            });
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                faculty: $scope.faculty,
                activeState: $scope.activeState
            });
        };

        $scope.export = function () {
            Lecturer.exportList({
                query: $stateParams.query ? $stateParams.query : "",
                faculty: $stateParams.faculty ? $stateParams.faculty : "",
                activeState: $stateParams.activeState ? $stateParams.activeState : ""
            })
        };

        $scope.analytics = function () {
            Lecturer.analytics({
                query: $stateParams.query ? $stateParams.query : "",
                faculty: $stateParams.faculty ? $stateParams.faculty : "",
                activeState: $stateParams.activeState ? $stateParams.activeState : ""
            })
        };
    }
]);
